import React from "react";

/**
 * Shared Open / Closed status filter. Optionally include Expired (derived UI phase used by Events).
 * @param {string} value - 'all' | 'open' | 'closed' | 'expired'
 * @param {(next: string) => void} onChange
 * @param {string} [label]
 * @param {boolean} [includeExpired] - when true, adds Expired option (Events)
 */
export default function OpenClosedFilterDropdown({
  value,
  onChange,
  label = "Status",
  includeExpired = false,
}) {
  const allowed = includeExpired
    ? new Set(["all", "open", "closed", "expired"])
    : new Set(["all", "open", "closed"]);
  const v = allowed.has(value) ? value : "all";

  return (
    <label className="toolbar-open-closed-filter">
      {label ? <span className="toolbar-label">{label}</span> : null}
      <select
        className="input toolbar-control"
        value={v}
        onChange={(e) => onChange(e.target.value)}
        aria-label={`${label} filter`}
      >
        <option value="all">— All —</option>
        <option value="open">Open</option>
        {includeExpired ? <option value="expired">Expired</option> : null}
        <option value="closed">Closed</option>
      </select>
    </label>
  );
}
